// src/pages/Blogs.js 
// (Assuming this file contains your Blogs component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import BlogContent from './PageComponent/BlogContent'

function Blogs() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Blogs | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Welcome to our blog, full of our ideas and passions. We care about creating beautiful window coverings as you care about creating an elegant home."
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/blogs/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Blogs" />
                <meta
                    property="og:description"
                    content="Welcome to our blog, full of our ideas and passions. We care about creating beautiful window coverings as you care about creating an elegant home."
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/blogs/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <BlogContent />
                <Footer />
            </div>
        </>
    );
}

export default Blogs;